import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer-premium">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-brand">
                        <div className="footer-logo">
                            <span className="logo-icon">🕉️</span>
                            <div className="brand-text-group">
                                <span className="logo-text-footer">Habla con Krishna</span>
                                <span className="trademark">®</span>
                            </div>
                        </div>
                        <p>Sabiduría antigua combinada con tecnología moderna</p>
                    </div>
                    <div className="footer-links">
                        <Link to="/about">Sobre nosotros</Link>
                        <Link to="/pricing">Planes</Link>
                        <Link to="/contact">Contacto</Link>
                        <Link to="/privacy">Privacidad</Link>
                        <Link to="/refund">Reembolsos</Link>
                        <Link to="/login">Iniciar sesión</Link>
                        <Link to="/signup">Registrarse</Link>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>© 2026 Habla con Krishna<span className="trademark" style={{ verticalAlign: 'middle', fontSize: '0.8em' }}>®</span>. Todos los derechos reservados.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
